export default __webpack_public_path__ + "static/PromptIconThree-ba7f4b7298c38da18b8b90229bcde658.png";